import { RecipePreferenceForm } from "@/components/RecipePreferenceForm";

const Index = () => {
  return <RecipePreferenceForm />;
};

export default Index;
